"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var size = {
  '3XLarge': '64px',
  '2XLarge': '48px',
  'XLarge': '32px',
  'Large': '28px',
  'Medium': '24px',
  'Small': '20px',
  'XSmall': '16px',
  '2XSmall': '14px',
  '3XSmall': '12px',
  '4XSmall': '10px'
};
var _default = size;
exports["default"] = _default;